import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, Navigate } from "react-router-dom";
import Auth0 from "../actions/auth/Auth";
import { actionCreators as userActionCreators, SET_SERVER_AUTH } from "../../data/user/actions";

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const authenticated = useSelector(state => state.auth.authenticated);
  const email = useSelector(state => state.user.clientInfo.email);
  const emailVerified = useSelector(state => state.user.clientInfo.email_verified);
  const serverAuthenticated = useSelector(state => state.user.serverAuthenticated);

  const redirectToVerify = email && !emailVerified && location.pathname !== "/verify";

  const skipMfaCheck = ['/mfa', '/callback', '/login', '/verify', '/delivery']
    .some(path => location.pathname.startsWith(path));

  const prevAuthenticatedRef = useRef(authenticated);

  useEffect(() => {
    if (authenticated) {
      dispatch(userActionCreators.didSessionExpire());
    }
    dispatch(userActionCreators.setAuth0ClientInfo(Auth0.getClientInfo()));
  }, []);

  useEffect(() => {
    const prevAuthenticated = prevAuthenticatedRef.current;
    prevAuthenticatedRef.current = authenticated;

    if (!prevAuthenticated && authenticated) {
      dispatch(userActionCreators.setAuth0ClientInfo(Auth0.getClientInfo()));
    }
  }, [authenticated, dispatch]);

  useEffect(() => {
    if (authenticated && !skipMfaCheck) {
      dispatch({ type: SET_SERVER_AUTH, payload: null }); // reset while fetching
      dispatch(userActionCreators.checkServerAuth());
    }
  }, [authenticated, location.pathname, dispatch]);

  if (redirectToVerify) {
    return <Navigate to="/verify" replace />;
  }

  if (authenticated && serverAuthenticated === false && !skipMfaCheck) {
    return <Navigate to={`/mfa?returnUrl=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return children;
};

export default AuthProvider;
